import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.component('nav-link', {
  template: require('./template.html'),
  name: 'nav-link',
  props: ['link', 'is-sub-link', 'display', 'droplet'],
  computed: {
    ...mapGetters(['currentPage']),
    hasSubLinks() {
      return this.link.subLinks.length > 0;
    },
  },
  methods: {
    isActive(link) {
      return link.pageLink === this.currentPage._id;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/navigation/components/nav-link/index.js